module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-6a86068c!./packages/dof-slider/diablo.css
// module id = 506
// module chunks = 0 1